<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="sourcebill" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<sourcebill-form :options="options" :data="currentrow" ref="sourcebillForm" @submit="sourcebillFormSubmit" @modalhide="sourcebillHide" />
			</el-main>
		</el-container>
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import sourcebillForm from '../../lib/sourcebill/config/form'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				loading:false,
				foreingKey:{},
				currentrow:{},
				options:[],
				list_formConfig: [{
					field: 'billtype',
					title: '账单类型',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				console.log(page,updateForm,other)
				return new Promise(resolve => {
					this.$api.sourcebill.list({
						...page,
						...updateForm,
						...other,
					}).then((res)=>{
						this.options = res.options
						resolve(res)
					},()=>{
						this.loading = false
					})
				})

				
				// return new Promise(resolve => {
				// 	this.$api.report.reportlist(this.reportName,{
				// 		...page,
				// 		...updateForm,
				// 		...other,
				// 		...this.foreingKey,
				// 		...{
				// 			fundtype:this.fundtype,
				// 			bancktype:this.bancktype,
				// 		}
				// 	}).then((res) => {
				// 		this.sourcedata = JSON.parse(JSON.stringify(res.list))
				// 		if (this.afterGet) {
				// 			this.afterGet(res,updateForm)
				// 		}
				// 		resolve(res)
				// 	}, () => {
				// 		resolve([])
				// 	})
				// })
			},		
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'sourcebill_list'
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50,2000,5000],
				}
				gridOptions.columns = [			
					{field:'billtype',title:'账单类型',props:{show:true}},
					{
						field:'jindietype',
						title:'星空模块',
						props:{
							show:true,
						},
						slots: {
							default: ({row}) => {
								let map = {
									CN_BANKTRANSBILL:'银行转账单',
									CN_JOURNAL:'手工日记账'
								}
								return map[row.jindietype]
							}
						}
					},
					{
						field:'settlementtype',
						title:'结算方式',
						render:'',
						props:{show:true},
						slots: {
							default: ({row}) => {
								let target = this.options.settlementtype.find((item)=>{
									return item.value == row.settlementtype
								})
								return target ? target.label :''
							}
						}
					},
					{
						field:'accountplant',
						title:'账户平台',
						render:'',
						props:{show:true},
						slots: {
							default: ({row}) => {
								let target = this.options.accountplant.find((item)=>{
									return item.value == row.accountplant
								})
								return target ? target.label :''
							}
						}
					},
					{field:'mark',title:'备注',render:'',props:{show:true}},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.checkboxConfig = null
				
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
			},
			add(){
				this.$refs.sourcebillForm.modal_show()
			},
			edit(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.sourcebillForm.modal_show()
				})
			},
			del(row){
				this.$confirm('是否确认删除' , '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.sourcebill.delete(row.id).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})				
			},
			sourcebillFormSubmit(){
				this.customreload()
			},
			sourcebillHide(){
				this.currentrow = {}
			},
			customreload(){
				this.$refs.sourcebill.commitProxy('query')
			},
		},
		components: {
			sourcebillForm
		}
	}
</script>